import { useContext } from 'react';
import { AuthContext } from '../../../shared/contexts/Auth';
import { CreditNoteList } from '../../AppAdmin/D2R/CreditNote/CreditNoteList';
export const creditnoteRoute = '/creditnote';

export function CreditNotes() {
	const { authState } = useContext(AuthContext);

	return <CreditNoteList isWms={true} company={authState.selectedCompanyIds} />;
}
